export const ACTIVITY_FEED_PUSH_RECEIVED = 'activity-feed:push-received';
export const ACTIVITY_FEED_PUSH_OPENED = 'activity-feed:push-opened';

export const getPushCategory = (data: any): string | null => {
  if (typeof data === 'string') {
    try {
      return getPushCategory(JSON.parse(data));
    } catch (error) {
      return data;
    }
  }

  return data?.category || data?.threadId || data?.type ||
    (typeof data?.customData === 'string' ? getPushCategory(data.customData) : data?.customData?.category) ||
    data?.payload?.customData?.category || data?.data?.category || data?.aps?.['thread-id'] || null;
};

declare global {
  interface Window {
    handlePushReceived?: (data: any) => void;
    __pendingActivityFeedRefresh?: boolean;
  }
}

// Receipt is an invalidation signal, separate from the navigation caused by a tap.
export const handlePushReceived = (data: any) => {
  if (getPushCategory(data) !== 'activity_feed') { return; }
  window.__pendingActivityFeedRefresh = true;
  window.dispatchEvent(new Event(ACTIVITY_FEED_PUSH_RECEIVED));
};
